import getCards from 'api/v1/transactions/getCards';
import { isAccountableBankingAuthorizationFailure } from 'components/pages/Banks/Wallet/helpers';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import type { Card, Connector } from 'types/transactions.types';
import { getStoredAuthData } from 'utils/auth';
import useGetConnectors from './useGetConnectors';
import useHasAccountableBanking from './useHasAccountableBanking';

const useGetCardsList = (
  onSuccess?: (cardsList: Card[]) => void,
): UseQueryResult<Card[]> => {
  const { data } = useGetConnectors();
  const accessToken = getStoredAuthData('access_token');
  const isAuthenticated = !!accessToken;
  const hasAccountableBanking = useHasAccountableBanking();

  const connectors = (data || []) as Connector[];

  const failedAuthorization = connectors.some(
    isAccountableBankingAuthorizationFailure,
  );

  return useQuery([BankTransactionsCacheKeys.Cards], getCards, {
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    enabled: Boolean(
      isAuthenticated && hasAccountableBanking && !failedAuthorization,
    ),
  });
};

export default useGetCardsList;
